import * as React from 'react';
import type { SVGProps } from 'react';

const SvgBitcoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={60} height={56} {...props}>
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero" transform="translate(1 1)">
        <path
          fill="silver"
          d="M58 27c0 .34-.01.67-.03 1a25.798 25.798 0 0 1-.89 6c-.18.68-.39 1.35-.62 2a26.55 26.55 0 0 1-3.01 6c-.46.69-.96 1.36-1.48 2A26.949 26.949 0 0 1 31 54c-.67 0-1.34-.02-2-.08V.08C29.66.02 30.33 0 31 0a26.949 26.949 0 0 1 20.97 10c.527.641 1.02 1.309 1.48 2a26.549 26.549 0 0 1 3.01 6c.23.65.44 1.32.62 2 .532 1.958.83 3.972.89 6 .02.33.03.66.03 1Z"
        />
        <circle cx={27} cy={27} r={27} fill="silver" />
        <ellipse cx={25.5} cy={27} fill="#DBDCDE" rx={25.5} ry={27} />
        <path
          fill="#EBEBEB"
          d="M27 46C16.507 46 8 37.493 8 27S16.507 8 27 8s19 8.507 19 19c-.012 10.488-8.512 18.988-19 19Z"
        />
        <path
          fill="#DBDCDE"
          d="M28 40v-3h-4v3h-4v-3h-3v-4h3v-5h-3v-4h3v-4h-3v-4h3v-3h4v3h4v-3h4v3.084A6.01 6.01 0 0 1 37 22a5.945 5.945 0 0 1-1.232 3.609A6.492 6.492 0 0 1 32 36.98V40h-4Zm3.5-7a2.5 2.5 0 1 0 0-5H24v5h7.5Zm-.5-9a2 2 0 1 0 0-4h-7v4h7Z"
        />
      </g>
      <g fill="#FFF" fillRule="nonzero">
        <path d="M28.91 54.98c-.3.01-.61.02-.91.02-.26 0-.51-.01-.77-.02-.24.01-.49.02-.73.02C12.42 55 1 42.91 1 28S12.42 1 26.5 1c.24 0 .49.01.73.02.26-.01.51-.02.77-.02l.9.02C15.1 1.35 4 13.3 4 28c0 14.7 11.1 26.66 24.91 26.98ZM33 1.08c-.17-.01-.34-.02-1.26-.07.086-.008.173-.012.26-.01.5 0 1 .01 1.5.05-.167 0-.334.01-.5.03ZM33 54.92c.166.02.333.03.5.03-.5.04-1 .05-1.5.05a2.618 2.618 0 0 1-.28-.01c.43-.01.86-.04 1.28-.07ZM30 54.92c.17.02.34.03 1.26.07A2.258 2.258 0 0 1 31 55c-.26 0-.51-.01-.77-.02-.24.01-.49.02-.73.02a4.094 4.094 0 0 1-.5-.02l1-.06ZM30 1.08l-1-.06c.166-.017.333-.024.5-.02.24 0 .49.01.73.02.26-.01.51-.02.77-.02.17 0 .34 0 .5.01-.5 0-1 .03-1.5.07Z" />
      </g>
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M0 28a28.69 28.69 0 0 1 3.195-12.965 27.843 27.843 0 0 1 4.412-6.182c.216-.233.423-.475.647-.7l.704-.641c.476-.42.926-.872 1.425-1.263a28.636 28.636 0 0 1 3.125-2.175A28.134 28.134 0 0 1 28 0v2a26.13 26.13 0 0 0-13.454 3.784 26.64 26.64 0 0 0-2.903 2.018c-.464.363-.88.785-1.323 1.174l-.656.595c-.207.21-.398.434-.599.65a25.843 25.843 0 0 0-4.098 5.742A26.688 26.688 0 0 0 2 28H0Z"
      />
      <path
        fill="#B5B5B5"
        fillRule="nonzero"
        d="M1.477 23.03a.978.978 0 0 0-1.14.841A31.814 31.814 0 0 0 0 28h2c.022-1.284.128-2.565.315-3.836a1.03 1.03 0 0 0-.838-1.135ZM28 2V0a28.134 28.134 0 0 0-14.492 4.074 28.636 28.636 0 0 0-3.125 2.175c-.5.391-.949.843-1.425 1.263l-.704.641c-.224.225-.43.467-.647.7a27.843 27.843 0 0 0-4.412 6.182l-.45.934a.97.97 0 0 0 .468 1.332c.5.217 1.083.012 1.337-.47l.417-.868a25.843 25.843 0 0 1 4.098-5.741c.2-.217.392-.442.6-.651l.655-.595c.443-.389.859-.81 1.323-1.174a26.64 26.64 0 0 1 2.903-2.018A26.13 26.13 0 0 1 28 2ZM1.22 19.822c-.065.267-.031.548.096.79l.114.16a.75.75 0 0 0 .15.135.627.627 0 0 0 .16.105c.061.028.124.051.188.07.255.064.524.031.757-.091a.978.978 0 0 0 .281-.253c.225-.311.269-.718.114-1.07a1.034 1.034 0 0 0-.241-.299 1.01 1.01 0 0 0-.332-.198 1.046 1.046 0 0 0-.773.047 1.02 1.02 0 0 0-.513.604Z"
      />
      <path
        stroke="#B5B5B5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M28 1c14.912 0 27 12.088 27 27S42.912 55 28 55 1 42.912 1 28"
      />
      <path
        stroke="#B5B5B5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M28 47C17.507 47 9 38.493 9 28S17.507 9 28 9s19 8.507 19 19c-.012 10.488-8.512 18.988-19 19Z"
      />
      <path
        stroke="#B5B5B5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M30 54.92c.66.06 1.33.08 2 .08 14.912 0 27-12.088 27-27S46.912 1 32 1c-.67 0-1.34.02-2 .08M53.75 12h-4M53.75 44h-4M57.8 20h-4M59 28h-4M57.8 36h-4"
      />
      <path
        stroke="#B5B5B5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M29 41v-3h-4v3h-4v-3h-3v-4h3v-5h-3v-4h3v-4h-3v-4h3v-3h4v3h4v-3h4v3.084A6.01 6.01 0 0 1 38 23a5.945 5.945 0 0 1-1.232 3.609A6.492 6.492 0 0 1 33 37.98V41h-4Zm3.5-7a2.5 2.5 0 1 0 0-5H25v5h7.5Zm-.5-9a2 2 0 1 0 0-4h-7v4h7Z"
      />
    </g>
  </svg>
);
export default SvgBitcoin;
